import { render, staticRenderFns } from "./DialogsVo.vue?vue&type=template&id=31133c84&"
import script from "./DialogsVo.vue?vue&type=script&lang=js&"
export * from "./DialogsVo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports